import { InsuranceName, MonthlyInstalment } from 'scenes/common/types';
import { requestDefaults, wireProduct } from '../marshaller';
import { WirePremiumFrequencies, WireStatus } from '../types';
import {
  WireMonthlyInstalmentFromApi,
  WireMonthlyInstalmentResponse,
} from './types';

export const marshalMonthlyInstalment = (
  insuranceName: InsuranceName,
  policyNumber: string,
  policyReference: string,
  paymentDate: string
) => ({
  ...requestDefaults(wireProduct[insuranceName]),
  targetStatus: WireStatus.RecalculateInstallments,
  policyNumber,
  policyReference,
  paymentDate,
});

export const unmarshalFirstInstalment = (
  quote: WireMonthlyInstalmentFromApi
): string =>
  quote.premiums
    .find((p) => p.frequency === WirePremiumFrequencies.First)
    ?.instalment?.toString() || '';

export const unsmarshalMonthlyInstalment = (
  quote: WireMonthlyInstalmentFromApi
): string =>
  quote.premiums
    .find((p) => p.frequency === WirePremiumFrequencies.Monthly)
    ?.instalment?.toString() || '';

export const unmarshalResponse = (
  response: WireMonthlyInstalmentResponse
): MonthlyInstalment => ({
  firstInstalment: unmarshalFirstInstalment(response.payload),
  monthlyInstalment: unsmarshalMonthlyInstalment(response.payload),
});
